<template>
	<v-container fluid v-resize="updateDataTableHeight">
		<v-container fluid class="ma-0 pa-0 pt-3 pb-6 header-container">
			<v-row align="center">
				<v-col
					class="d-flex"
					cols="6"
					md="3" 
					sm="6"
				>
					<img class="logo" src="../assets/logo-sc.png" alt="ScienceCloud">
				</v-col>
				<v-col class="search-bar" cols="6" sm="6" md="5">
					<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Wyszukaj w tabeli"
						single-line
						outlined
						dense
						hide-details
					></v-text-field>
				</v-col>
			</v-row>
		</v-container>
		<v-data-table
			:headers="headers"
			:items="filteredItems"
			:items-per-page="300"
			class="elevation-1"
			:custom-sort="customSort"
			dense
			:search="search"
			:loading="isLoaded"
			fixed-header
			hide-default-footer
			:height="dataTableHeight"
			mobile-breakpoint="1">
			<template v-slot:item="{ item }">
				<tr>
					<td v-for="(header, index) in headers" :key="index">
						<template v-if="(disciplineHeaders.includes(header.value)) ">
							<div class="pa-0" :class="getColor(item[header.value])">
								{{item[header.value]}}
							</div>
						</template>
						<template v-else-if="(header.value=='uczelnia')">
							<div class="pa-0 pl-4 justify-start">
								{{item[header.value]}}
							</div>
						</template>
						<template v-else>
							<div class="pa-0 pl-1 justify-start">
								{{item[header.value]}}
							</div>
						</template>
					</td>
				</tr>
			</template>

		</v-data-table>
	</v-container>
</template>

<script>
function filtered(item, option) {
	return function(obj) {
		let result=obj[item]
		if (result=="") result="Nie"
		return result == option
	}
}
import axios from 'axios';
export default {
	name: 'Table',
	computed: {
		disciplineHeaders() {
			let newHeaders = this.headers.slice(1,48)
			newHeaders = newHeaders.map(item => item.value)
			return newHeaders
		}
	},
	methods: {
		updateDataTableHeight () {
			if(window.innerWidth<960 && window.innerWidth>=600){
				this.dataTableHeight = 620
			}
			else if(window.innerWidth<600){
				this.dataTableHeight = 556
			}
			else{
				this.dataTableHeight = 700
			}
		},
		log(item){
			console.log(item)
		},
		getColor (cat) {
			if (cat == "A+") return 'super1'
			else if (cat == "A") return 'green1'
			else if (cat == "B+") return 'yellow1'
			else if (cat == "B") return 'orange1'
			else if (cat == "C") return 'red1'
			else return "transparent"
		},
		customSort(items, index, isDesc) {
			items.sort((a, b) => {
				if(a[index]&&b[index]){
					if (a[index].charAt(0) == b[index].charAt(0)) {
						if (a[index].charAt(a[index].length-1) == b[index].charAt(b[index].length-1)) {
							return 0
						}else{
							if(a[index].charAt(1)=="+"){
								return 0
							}else{
								return 1
							}
						}
				}
				}
				if (a[index] == b[index]) { 
					return 0
				} else if (a[index] == "") {
					return 1
				} else if (b[index] == "") {
					return -1
				} else if (!isDesc[0]) {
					return a[index] < b[index] ? -1 : 1
				} else { 
					return a[index] < b[index] ? 1 : -1
				}
			});
			return items;
		},
		filtering(event, type) {
			this.filters[type][1]=event
			/*sprawdza czy wszystkie filtry są wyzerowane, jeśli tak to jedzie tylko jeden filtr po obiekcie
			*/
			if(Object.values(this.filters).every(
				function(element, index, array) {
					return element[0] === false
				}
			)){
				if(event=="Wszystkie"){
					this.filters[type][0]=false
				}else{
					this.filters[type][0]=true
				}
				if(event=="Wszystkie"){
					this.filteredItems=this.listItems
				}else{
					this.filteredItems=this.listItems.filter(filtered(type, event))
				}
			}else{
				this.filteredItems = this.listItems
				if(event=="Wszystkie"){
					this.filters[type][0]=false
				}else{
					this.filters[type][0]=true
				}
				//jedzie wszystkie filtry po kolei i gdy active to dodaje do glownego filtra
				Object.keys(this.filters).forEach(key => {
					let isActive=this.filters[key][0]
					if(isActive){
						this.filteredItems=this.filteredItems.filter(filtered(key, this.filters[key][1]))
					}
				})
			}
		}
	},
	data: () => ({
		isLoaded: true,
		search: '',
		selected: null,
		all: 'Wszystkie',
		filteredItems: [],
		dataTableHeight: 700,
		uczelnia: '',
		itemsFinansowanie: ['Wszystkie', 'Prywatna', 'Publiczna'],
		itemsRodzaj: ['Wszystkie', 'Uniwersytet', 'Techniczna', 'Instytut PAN', 'Artystyczna', 'AWF', 'Medyczna', 'Specjalistyczna'],
		itemsIdub10: ['Wszystkie', 'Tak', 'Nie'],
		itemsIdub20: ['Wszystkie', 'Tak', 'Nie'],
		filters: {
			IDUB_10: [false, null],
			IDUB_20: [false, null]
		},
		headers: [
			{text: 'Uczelnia', value: 'uczelnia', class: 'fixed'},
			{text: 'Archeologia', value: 'archeologia'},
			{text: 'Filozofia', value: 'filozofia'},
			{text: 'Historia', value: 'historia'},
			{text: 'Językoznawstwo', value: 'językoznawstwo'},
			{text: 'Literaturoznawstwo', value: 'literaturoznawstwo'},
			{text: 'Nauki o kulturze i religii', value: 'nauki_o_kulturze_i_religii'},
			{text: 'Nauki o sztuce', value: 'nauki_o_sztuce'},
			{text: 'Architektura i urbanistyka', value: 'architektura_i_urbanistyka'},
			{text: 'Automatyka, elektronika i elektrotechnika', value: 'automatyka_elektronika_i_elektrotechnika'},
			{text: 'Informatyka techniczna i telekomunikacja', value: 'informatyka_techniczna_i_telekomunikacja'},
			{text: 'Inżynieria biomedyczna', value: 'inżynieria_biomedyczna'},
			{text: 'Inżynieria chemiczna', value: 'inżynieria_chemiczna'},
			{text: 'Inżynieria lądowa i transport', value: 'inżynieria_lądowa_i_transport'},
			{text: 'Inżynieria materiałowa', value: 'inżynieria_materiałowa'},
			{text: 'Inżynieria mechaniczna', value: 'inżynieria_mechaniczna'},
			{text: 'Inżynieria środ., górnictwo i energetyka', value: 'inżynieria_środowiska_górnictwo_i_energetyka'},
			{text: 'Nauki farmaceutyczne', value: 'nauki_farmaceutyczne'},
			{text: 'Nauki medyczne', value: 'nauki_medyczne'},
			{text: 'Nauki o kulturze fizycznej', value: 'nauki_o_kulturze_fizycznej'},
			{text: 'Nauki o zdrowiu', value: 'nauki_o_zdrowiu'},
			{text: 'Nauki leśne', value: 'nauki_leśne'},
			{text: 'Rolnictwo i ogrodnictwo', value: 'rolnictwo_i_ogrodnictwo'},
			{text: 'Technoologia żywności i żywienia', value: 'technologia_żywności_i_żywienia'},
			{text: 'Weterynaria', value: 'weterynaria'},
			{text: 'Zootechnika i rybactwo', value: 'zootechnika_i_rybactwo'},
			{text: 'Ekonomia i finanse', value: 'ekonomia_i_finanse'},
			{text: 'Geografia społ.-ekon. i gospodarka prz.', value: 'geografia_społeczno-ekonomiczna_i_gospodarka_przestrzenna'},
			{text: 'Nauki o bezpieczeństwie', value: 'nauki_o_bezpieczeństwie'},
			{text: 'Nauki o komunikacji społecznej i mediach', value: 'nauki_o_komunikacji_społecznej_i_mediach'},
			{text: 'Nauki o polityce i administracji', value: 'nauki_o_polityce_i_administracji'},
			{text: 'Nauki o zarządzaniu i jakości', value: 'nauki_o_zarządzaniu_i_jakości'},
			{text: 'Nauki prawne', value: 'nauki_prawne'},
			{text: 'Nauki socjologiczne', value: 'nauki_socjologiczne'},
			{text: 'Pedagogika', value: 'pedagogika'},
			{text: 'Prawo kanoniczne', value: 'prawo_kanoniczne'},
			{text: 'Psychologia', value: 'psychologia'},
			{text: 'Astronomia', value: 'astronomia'},
			{text: 'Informatyka', value: 'informatyka'},
			{text: 'Matematyka', value: 'matematyka'},
			{text: 'Nauki biologiczne', value: 'nauki_biologiczne'},
			{text: 'Nauki chemiczne', value: 'nauki_chemiczne'},
			{text: 'Nauki fizyczne', value: 'nauki_fizyczne'},
			{text: 'Nauki o Ziemi i środowisku', value: 'nauki_o_Ziemi_i_środowisku'},
			{text: 'Nauki teologiczne', value: 'nauki_teologiczne'},
			{text: 'Sztuki plastyczne i konserwacja dzieł sztuki', value: 'sztuki_plastyczne_i_konserwacja_dzieł_sztuki'},
			{text: 'Sztuki muzyczne', value: 'sztuki_muzyczne'},
			{text: 'Sztuki filmowe i teatralne', value: 'sztuki_filmowe_i_teatralne'},
			{text: 'A+', value: 'A+'},
			{text: 'A', value: 'A'},
			{text: 'B+', value: 'B+'},
			{text: 'B', value: 'B'},
			{text: 'C', value: 'C'},
			{text: 'IDUB-10', value: 'IDUB_10'},
			{text: 'IDUB-20', value: 'IDUB_20'}
		],
		listItems: [
		]
	}),
	mounted () {
		var host = window.location.origin
		let vm = this
		axios
			.get(host + '/ewaluacja_akt31_08.json')
			.then(response => (
				this.listItems = response.data
				
			))
			.then(() => {
				vm.filteredItems = vm.listItems
				this.isLoaded = false
			})
		document.querySelector(".v-data-table td").classList.add("text-start1");
	}
}
</script>
<style lang="scss">

table thead tr{
	background: #fff;
}


	.header-container{
		max-width: 928px;
		@include sm-down{
			max-width: calc(100vw - 24px);
		}
	}
	th:not(:first-child){
		span{
			-webkit-transform: rotate(180deg);
			transform: rotate(180deg);
			display: block;
			writing-mode: vertical-rl;
			
		}
		&.fixed{
			position: sticky;
			left: 0;
			top: auto;
		}
		writing-mode: vertical-rl;
		-ms-writing-mode: vertical-rl;
		-webkit-writing-mode: vertical-rl;
		-moz-writing-mode: vertical-rl;
	}
	th{
		span{
			display: block;
		}
		padding-left: 2px!important;
		vertical-align: bottom;
		font-size: 10px!important;
		height: 230px!important;
		padding-bottom: 20px!important;
		.v-icon.v-icon{
			position: absolute;
			bottom: 0;
			left: 3px;
		}
		&.sortable.desc{
			.v-icon.v-icon{
				position: absolute;
				bottom: 0px;
			}
		}
	}
	th{
		position: relative;
		&:first-child span{
			color: midnightblue;
			font-size: 12px;
			position: relative;
			left: 15px;
		}
		&:first-child{
			.v-icon.v-icon{
				left: 15px;
			}
		}
	}
	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > tbody > tr > th, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > th, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th{
		padding: 0;
		min-width: 20px;
		font-size: 12px;
		color: black;
		min-width: 15px!important;
	}
	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td{
		padding-left:0;
		box-sizing: border-box;
		color: black;
	}
	th, td{
		&:nth-child(even){
			background-color: #f6f6f6;
		}
	}
	th{
		&:nth-child(even){
			background-color: #f6f6f6!important;
		}
	}
	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td{
		height: 24px;
	}
	tr > td:first-child{
	}
	tr > td{
		white-space: nowrap;
	}
	.v-select{
		font-size: 0.75em!important;
	}
	.v-label{
		font-size: 1em!important;
	}
	th i.mdi{
	}
	.v-text-field--outlined fieldset{
		border-radius: 20px;
		border: 1px solid #aaa;
	}
	.search-bar .v-text-field{
		border-radius: 20px;
		//border: 1px solid #aaa;
		input, label{
			font-size: 14px!important;
		}
	}
	.v-select__slot{
		input{
			cursor: pointer!important;
			color: #053a6e;
		}
	}
	.logo{
		height: 32px;
		position: relative;
		width: 160px;
		@include xs{
			width: 120px;
			height: 24px;
		}
	}
	td{
		padding: 0;
		padding-left: 0;
		padding-right: 0;
		div{
			padding: 0 2px;
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	tbody>tr>td:first-child{
		letter-spacing: -0.5px;
	}
	.super1{
		background-color: #dff5e1;
	}
	.green1{
		background-color: #effbea;
	}
	.yellow1{
		background-color: #fffff1;
	}
	.orange1{
		background-color: #fff2f0;
	}
	.red1{
		background-color: #ffd0d0;
	}
</style>